"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBulletResponse = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateBulletResponse = (0, validation_1.properties)({
    status: (0, validation_1.text)(),
    error: (0, validation_1.optional)((0, validation_1.text)()),
    generatedBullets: (0, validation_1.array)((0, validation_1.text)()),
});
//# sourceMappingURL=BulletResponse.js.map